export var SmartCheckpoint;
(function (SmartCheckpoint) {
    SmartCheckpoint["ON_PHONE_NUMBER_VALIDATION_CHECK"] = "ON_PHONE_NUMBER_VALIDATION_CHECK";
    SmartCheckpoint["ON_REQUEST_CODE_CHECK"] = "ON_REQUEST_CODE_CHECK";
    SmartCheckpoint["ON_NEW_CUSTOMER_CHECK"] = "ON_CHECK_NEW_CUSTOMER";
    SmartCheckpoint["ON_CODE_RESEND_CHECK"] = "ON_CODE_RESEND_CHECK";
    SmartCheckpoint["ON_CHANGE_PHONE_NUMBER_CHECK"] = "ON_CHANGE_PHONE_NUMBER_CHECK";
    SmartCheckpoint["ON_CODE_VALIDATION_CHECK"] = "ON_CODE_VALIDATION_CHECK";
    SmartCheckpoint["ON_CODE_VERIFY_CHECK"] = "ON_CODE_VERIFY_CHECK";
    SmartCheckpoint["ON_NAME_CHECK"] = "ON_NAME_CHECK";
    SmartCheckpoint["ON_EMAIL_VALIDATION_CHECK"] = "ON_EMAIL_VALIDATION_CHECK";
    SmartCheckpoint["ON_ERROR_CHECK"] = "ON_ERROR_CHECK";
    SmartCheckpoint["ON_FINAL_CHECK"] = "ON_FINAL_CHECK";
})(SmartCheckpoint || (SmartCheckpoint = {}));
export var SmartExperimentCheckpoint;
(function (SmartExperimentCheckpoint) {
    SmartExperimentCheckpoint["ON_SIGN_IN_CHECK"] = "ON_SIGN_IN_CHECK";
    SmartExperimentCheckpoint["ON_VERIFY_CHECK"] = "ON_VERIFY_CHECK";
})(SmartExperimentCheckpoint || (SmartExperimentCheckpoint = {}));
export var StepNames;
(function (StepNames) {
    StepNames["START_STEP_BUTTONS"] = "START_STEP_BUTTONS";
    StepNames["MESSAGE_LIST"] = "MESSAGE_LIST";
    StepNames["VERIFY"] = "VERIFY";
    StepNames["SIGNIN"] = "SIGNIN";
    StepNames["INITIAL_MESSAGES"] = "INITIAL_MESSAGES";
})(StepNames || (StepNames = {}));
//# sourceMappingURL=index.js.map